import { useParams } from 'react-router-dom'
import { useLanguage } from 'languages/language'

import { ProjectIntro } from '../projectintro'

import { Container } from 'styles/global'
import * as P from './styled'

import { Fragment } from 'react'
import { screen } from 'styles/mq'
import { imageSize } from 'components/hooks/utils'

const ProjectPage: React.FC<{ category: string }> = ({ category }) => {
  const { id } = useParams<{ id: string }>()
  const { texts } = useLanguage()

  if (!id) return null
  const project =
    category === 'web'
      ? texts.web[Number(id) - 1]
      : category === 'dalsi'
        ? texts.others[Number(id) - 1]
        : texts.interests[Number(id) - 1]
  return (
    <Container>
      <P.Content>
        {project && (
          <>
            <ProjectIntro project={project} />

            {project.imgs.map((img, index) => {
              return (
                <Fragment key={`${img}-${index}`}>
                  {img.endsWith('.mp4') ? (
                    <>
                      <video key={img} loop autoPlay muted playsInline>
                        <source src={img} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                      {project.texts !== undefined &&
                        project.texts[index] !== undefined && (
                          <p>{project.texts[index]}</p>
                        )}
                    </>
                  ) : (
                    <figure key={index}>
                      <picture>
                        <source
                          media={'(min-width:' + screen.m + ')'}
                          srcSet={imageSize(img, 'm')}
                        />
                        <source
                          media={'(min-width:' + screen.xl + ')'}
                          srcSet={imageSize(img, 'l')}
                        />
                        <img alt="" src={imageSize(img, 's')} />
                      </picture>
                      {project.texts !== undefined &&
                        project.texts[index] !== undefined && (
                          <figcaption>{project.texts[index]}</figcaption>
                        )}
                    </figure>
                  )}
                </Fragment>
              )
            })}
          </>
        )}
      </P.Content>
    </Container>
  )
}
export default ProjectPage
